import { createRef, useCallback } from "react";

import { Button } from "@aircall/ds";
import { Player } from "@lottiefiles/react-lottie-player";
import { useTranslation } from "react-i18next";

import { AnimatedScreenProps } from "./AnimatedScreen.decl";

export function AnimatedScreen({
  title,
  children,
  imgSrc,
  hasReloadButton = true,
  shouldShowImgFirst = true,
  dataTest,
}: AnimatedScreenProps) {
  const { t } = useTranslation();
  const playerRef = createRef<Player>();

  const handleOnClick = useCallback(() => window.location.reload(), []);

  return (
    <div
      className="flex h-full flex-col items-center bg-muted px-8 pt-[100px] sm:px-10 md:px-16"
      data-test={dataTest}
    >
      {imgSrc && (
        <Player
          ref={playerRef}
          autoplay
          loop
          controls
          src={imgSrc}
          style={{ width: "730px" }}
        />
      )}
      <div
        className={`max-w-[730px] text-center ${
          shouldShowImgFirst ? "order-2" : "-order-1"
        }`}
      >
        <h2
          className="m-0 mb-6 text-[42px] leading-10 font-bold"
          data-test="animated-screen-title"
        >
          {title}
        </h2>
        <p
          className="mb-10 text-sm font-medium whitespace-pre-line"
          data-test="animated-screen-content"
        >
          {children}
        </p>
        {hasReloadButton && (
          <Button
            size="lg"
            onClick={handleOnClick}
            data-test="animated-screen-reload-button"
          >
            {t("error_screen.buttons.reload_button_label")}
          </Button>
        )}
      </div>
    </div>
  );
}
